import chatify from "../Assets/Projects/chatify.png";
import bitsOfCode from "../Assets/Projects/blog.png";
import editor from "../Assets/Projects/codeEditor.png";
import leaf from "../Assets/Projects/leaf.png";
import suicide from "../Assets/Projects/suicide.png";
import emotion from "../Assets/Projects/emotion.png";

// Career entries, newest first. Content is taken from the resume.
// `impact` is the headline result, `flow` the one-line architecture,
// `highlights` the key things built. `image` is only used by the old design.
export const PROJECTS_DATA = [
  {
    id: 1,
    title: "Single Pane of Glass hotel operations platform",
    role: "Senior Full Stack Engineer",
    company: "Marriott International",
    companyLink: "https://www.marriott.com",
    location: "Bethesda, MD",
    period: "Oct 2024 – Sep 2026",
    description:
      "Built a platform that unified reservation, room, guest, loyalty, and service information so front-desk teams manage guest stays from one application.",
    impact: "Up to 60% faster high-traffic queries, shorter front-desk tasks",
    flow: ["Next.js (RSC)", "Apollo Federation", "NestJS", "Redis", "Kafka + SQS", "ECS"],
    highlights: [
      "Unified hotel data behind NestJS services as Apollo Federation subgraphs, giving a type-safe interface for the whole front desk.",
      "Built guided check-in, checkout, room-move, and loyalty-enrollment flows that cut average task-completion time.",
      "Added AI-assisted search that turns natural-language questions into authorized, grounded answers across reservation, room, and guest data.",
      "Used DataLoader batching and Redis caching to speed targeted high-traffic queries by up to 60%.",
      "Connected property-management systems and Salesforce through Kafka, SNS, and SQS, with live updates over Socket.IO.",
    ],
    image: chatify,
    technologies: [
      "Next.js",
      "React Server Components",
      "TypeScript",
      "NestJS",
      "GraphQL",
      "Apollo Federation",
      "Redis",
      "Kafka",
      "AWS ECS",
      "Jest",
      "Cypress",
    ],
    demoLink: "",
    githubLink: "",
    isBlog: false,
  },
  {
    id: 2,
    title: "Rider web experience and infrastructure insights",
    role: "Senior Full Stack Engineer",
    company: "Uber",
    companyLink: "https://www.uber.com",
    location: "San Francisco, CA",
    period: "Apr 2022 – Oct 2024",
    description:
      "Revamped the booking web experience on the new design system and led an in-house platform that shows infrastructure efficiency.",
    impact: "15% more first-trip conversions, 22% fewer support contacts",
    flow: ["React monorepo", "Node.js services", "gRPC + GraphQL", "ML pricing APIs", "Cloud Run"],
    highlights: [
      "Redesigned the booking flow, raising first-trip conversions 15% globally.",
      "Built Node.js dispatch and driver-rider matching services with gRPC and GraphQL across a microservices architecture.",
      "Shipped a live Google Maps ride-tracking UI that cut support contacts during active trips by 22%.",
      "Built Python anomaly-detection and forecasting jobs behind cost dashboards, so teams spot infrastructure waste sooner.",
      "Kept Cloud Run services above 99.9% availability and mentored 3 junior engineers.",
    ],
    image: bitsOfCode,
    technologies: [
      "React",
      "Redux",
      "TypeScript",
      "Node.js",
      "gRPC",
      "GraphQL",
      "Python",
      "Chart.js",
      "Grafana",
      "Google Cloud",
      "Cypress",
    ],
    demoLink: "",
    githubLink: "",
    isBlog: false,
  },
  {
    id: 3,
    title: "Walmart+ membership platform",
    role: "Senior Full Stack Engineer",
    company: "Walmart",
    companyLink: "https://www.walmart.com",
    location: "Sunnyvale, CA",
    period: "Jun 2019 – Mar 2022",
    description:
      "Built end-to-end membership and engagement features for Walmart+, supporting its launch and continued growth.",
    impact: "25% more reviews per customer, 18% more review engagement",
    flow: ["Next.js", "GraphQL", "Node.js", "Python ML services", "AWS"],
    highlights: [
      "Built self-service flows for plan upgrades, pauses, cancellations, payment updates, and billing dates, easing the load on support.",
      "Created a personalized membership hub and used A/B tests to improve plan selection and conversion.",
      "Raised reviews submitted per customer by 25% with accessible rich-text review workflows.",
      "Built Python ML ranking and moderation services that lifted engagement with relevant reviews by 18% and flagged abuse automatically.",
      "Created reusable Storybook components in an Nx monorepo to speed up feature delivery.",
    ],
    image: editor,
    technologies: [
      "Next.js",
      "React",
      "TypeScript",
      "Node.js",
      "GraphQL",
      "Python",
      "Nx",
      "Storybook",
      "AWS",
      "Grafana",
      "Splunk",
    ],
    demoLink: "",
    githubLink: "",
    isBlog: false,
  },
  {
    id: 4,
    title: "Auto financing web application",
    role: "Software Engineer",
    company: "Carputty",
    companyLink: "https://www.carputty.com",
    location: "Atlanta, GA",
    period: "Feb 2017 – Jun 2019",
    description:
      "Built an early-stage platform, later part of Carputty, that lets borrowers purchase, refinance, or lease vehicles with ease.",
    impact: "Automated credit applications and verification",
    flow: ["Next.js", "REST APIs", "Experian + Plaid", "PostgreSQL"],
    highlights: [
      "Simplified multi-step financing applications and account management for borrowers.",
      "Built APIs for authentication, credit applications, decisions, and status, cutting manual processing for operations.",
      "Integrated Experian for credit data and Plaid for bank verification to speed up applicant checks.",
      "Designed transactional PostgreSQL models that keep a traceable history of every financing decision.",
      "Protected sensitive data with OAuth 2.0, JWT, role-based access control, and validation.",
    ],
    image: leaf,
    technologies: [
      "React",
      "Next.js",
      "TypeScript",
      "Node.js",
      "PostgreSQL",
      "OAuth 2.0",
      "JWT",
      "Plaid",
    ],
    demoLink: "",
    githubLink: "",
    isBlog: false,
  },
  {
    id: 5,
    title: "Clean-beauty e-commerce platform",
    role: "Software Engineer",
    company: "Beautycounter",
    companyLink: "https://www.beautycounter.com",
    location: "Santa Monica, CA",
    period: "Nov 2015 – Feb 2017",
    description:
      "Built and optimized the customer-facing e-commerce platform, improving shopping performance, checkout reliability, and engagement.",
    impact: "30% faster page loads, 15% more engagement",
    flow: ["React", "Express APIs", "Redis cache", "Kafka events", "Stripe + PayPal"],
    highlights: [
      "Built responsive shopping, account, and checkout experiences for desktop and mobile.",
      "Used Redis caching and Kafka order and fulfillment events to reduce database load in high-traffic periods.",
      "Integrated tokenized Stripe and PayPal payments with structured error handling.",
      "Cut measured page-load time by 30% through bundle, code-splitting, and caching work.",
      "Used A/B tests with Optimizely to lift customer engagement by 15%.",
    ],
    image: suicide,
    technologies: [
      "React",
      "Node.js",
      "Express",
      "PostgreSQL",
      "Redis",
      "Kafka",
      "Stripe",
      "Webpack",
      "Jenkins",
      "AWS",
    ],
    demoLink: "",
    githubLink: "",
    isBlog: false,
  },
  {
    id: 6,
    title: "Investor Center platform",
    role: "Software Engineer",
    company: "JLL",
    companyLink: "https://www.jll.com",
    location: "Chicago, IL",
    period: "Oct 2014 – Nov 2015",
    description:
      "Helped build a digital platform giving investors one place to explore commercial property listings, market information, and opportunities worldwide.",
    impact: "25% faster property search, 20% fewer frontend defects",
    flow: ["React", "Node.js REST API", "MongoDB (indexed)"],
    highlights: [
      "Built responsive property search, results, and detail experiences with reusable filters and shared components.",
      "Created Node.js APIs as a consistent layer over listings, market, and investment data.",
      "Designed MongoDB collections and compound indexes that sped up search and API responses by about 25%.",
      "Wrote Jest tests that led to roughly 20% fewer frontend regression defects.",
    ],
    image: emotion,
    technologies: ["React", "JavaScript", "Node.js", "MongoDB", "Jest"],
    demoLink: "",
    githubLink: "",
    isBlog: false,
  },
];

export const SKILL_GROUPS = [
  ["Languages", "TypeScript, JavaScript, Python, SQL"],
  ["Frontend", "React, Next.js, React Native, Tailwind CSS, Storybook"],
  ["Backend and APIs", "Node.js, NestJS, FastAPI, Django, GraphQL, REST, gRPC"],
  ["Data and messaging", "PostgreSQL, MongoDB, Redis, Kafka, SQS, SNS"],
  ["Cloud and delivery", "AWS, GCP, Vercel, Docker, Kubernetes, CI/CD"],
  ["AI integration", "LLM workflows, natural-language data retrieval, generative video, image, and audio"],
];

export const EDUCATION = {
  school: "Radford University",
  place: "Radford, Virginia",
  degree: "Bachelor's degree, Computer Science",
  year: "2010 – 2014",
};
